import { AddIcon } from '@chakra-ui/icons';

import MicrosoftIcon from 'components/icons/MicrosoftIcon';
import EightByEightIcon from 'components/icons/EightByEightIcon';
import ZoomIcon from 'components/icons/ZoomIcon';
import SBCIcon from 'components/icons/SBCIcon';
import GCCHighIcon from 'components/icons/GCCHighIcon';
import WebexIcon from 'components/icons/WebexIcon';
import OperatorPlatformIcon from 'components/icons/OperatorPlatformIcon';
import RingCentralIcon from 'components/icons/RingCentralIcon';
import DialPadIcon from 'components/icons/DialPadIcon';

import {
    MICROSOFT_GRAPH,
    TPM,
    OPERATOR_CONNECT,
    ZOOM,
    EIGHTBYEIGHT,
    EIGHTBYEIGHT_AUTH,
    ACS,
    SBC,
    DIRECT_ROUTING,
    VENDOR_DEFINED,
    OPERATOR_PLATFORM,
    ZOOM_AUTH,
    OPERATOR_CONNECT_CONFERENCING,
    GCC_HIGH,
    WEBEX,
    WEBEX_AUTH,
    SRT,
    RINGCENTRAL,
    RINGCENTRAL_AUTH,
    DIALPAD,
    DIALPAD_AUTH,
} from '../constants';

export const accordionCategory = [
    {
        title: 'Cisco Webex',
        services: [WEBEX, WEBEX_AUTH],
        icon: WebexIcon,
    },
    {
        title: 'Microsoft',
        services: [
            MICROSOFT_GRAPH,
            TPM,
            OPERATOR_CONNECT,
            DIRECT_ROUTING,
            OPERATOR_CONNECT_CONFERENCING,
            ACS,
        ],
        icon: MicrosoftIcon,
    },
    {
        title: 'Zoom',
        services: [ZOOM, ZOOM_AUTH],
        icon: ZoomIcon,
    },
    {
        title: '8x8',
        services: [EIGHTBYEIGHT, EIGHTBYEIGHT_AUTH],
        icon: EightByEightIcon,
    },
    {
        title: 'Ring Central',
        services: [RINGCENTRAL, RINGCENTRAL_AUTH],
        icon: RingCentralIcon,
    },
    {
        title: 'Dial Pad',
        services: [DIALPAD, DIALPAD_AUTH],
        icon: DialPadIcon,
    },
    {
        title: 'SIP Trunks',
        services: [SBC, SRT],
        icon: SBCIcon,
    },
    {
        title: 'Microsoft Teams GCC High',
        services: [MICROSOFT_GRAPH, GCC_HIGH],
        icon: GCCHighIcon,
    },
    {
        title: 'Value Add Services',
        services: [VENDOR_DEFINED],
        icon: AddIcon,
    },
    {
        title: 'Operator Platform',
        services: [OPERATOR_PLATFORM],
        icon: OperatorPlatformIcon,
    },
];
